import { useCombobox, useMultipleSelection, } from 'downshift';
export const useSelectStateReducers = (args) => {
    const { callAddSelectedItem = () => {
        return;
    }, callCloseMenu = () => {
        return;
    }, callOpenMenu = () => {
        return;
    }, callSelectItem = () => {
        return;
    }, isMultiSelect, itemIsDisabled, renderItemToString, selectInput = { current: null }, updateFilteredItems, } = args;
    const safeItemIsDisabled = itemIsDisabled || (() => false);
    // State reducer for the MultiSelect component
    const multipleSelectionStateReducer = (_state, actionAndChanges) => {
        const { type, changes } = actionAndChanges;
        switch (type) {
            case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
            case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
            case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
                updateFilteredItems('', changes.selectedItems);
                return {
                    ...changes,
                    activeIndex: -1,
                };
            case useMultipleSelection.stateChangeTypes.FunctionAddSelectedItem:
            case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
            case useMultipleSelection.stateChangeTypes.FunctionSetSelectedItems:
                updateFilteredItems('', changes.selectedItems);
                return changes;
            default:
                return changes;
        }
    };
    const selectInputEvent = (selectInputEl, event) => {
        const selectInputCurrent = selectInputEl.current;
        if (selectInputCurrent) {
            switch (event) {
                case 'blur':
                    selectInputCurrent.blur();
                    break;
                case 'focus':
                    selectInputCurrent.focus();
                    break;
                default:
                    break;
            }
        }
    };
    const singleSelectReducer = (state, type, changes) => {
        switch (type) {
            case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
            case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
                if (!state.isOpen) {
                    updateFilteredItems('');
                    return {
                        ...changes,
                        highlightedIndex: 0,
                        inputValue: '',
                    };
                }
                return changes;
            case useCombobox.stateChangeTypes.InputKeyDownEnter:
                return {
                    ...changes,
                    inputValue: safeItemIsDisabled(changes.selectedItem) ? '' : renderItemToString(changes.selectedItem),
                    selectedItem: safeItemIsDisabled(changes.selectedItem) ? null : changes.selectedItem,
                    highlightedIndex: 0,
                };
            case useCombobox.stateChangeTypes.ItemClick:
                callCloseMenu();
                updateFilteredItems('', changes.selectedItem);
                return changes;
            case useCombobox.stateChangeTypes.InputKeyDownEscape:
            case useCombobox.stateChangeTypes.ToggleButtonClick:
                selectInputEvent(selectInput, 'blur');
                updateFilteredItems('');
                return {
                    ...changes,
                    inputValue: renderItemToString(changes.selectedItem),
                };
            case useCombobox.stateChangeTypes.FunctionOpenMenu:
                selectInputEvent(selectInput, 'focus');
                updateFilteredItems('', changes.selectedItem);
                return {
                    ...changes,
                    highlightedIndex: 0,
                    inputValue: '',
                };
            case useCombobox.stateChangeTypes.FunctionCloseMenu:
                selectInputEvent(selectInput, 'blur');
                updateFilteredItems('', changes.selectedItem);
                return {
                    ...changes,
                    inputValue: renderItemToString(changes.selectedItem),
                };
            case useCombobox.stateChangeTypes.FunctionSelectItem:
                updateFilteredItems('', changes.selectedItem);
                if (state.isOpen && !changes.inputValue) {
                    callCloseMenu();
                }
                return {
                    ...changes,
                    inputValue: renderItemToString(changes.selectedItem),
                };
            case useCombobox.stateChangeTypes.InputFocus:
                updateFilteredItems('');
                return {
                    ...changes,
                    highlightedIndex: 0,
                    inputValue: '',
                };
            case useCombobox.stateChangeTypes.InputBlur:
                return {
                    ...changes,
                    highlightedIndex: 0,
                    inputValue: renderItemToString(state.selectedItem),
                    selectedItem: state.selectedItem,
                };
            case useCombobox.stateChangeTypes.InputChange:
                updateFilteredItems(changes.inputValue);
                return state.selectedItem ? changes : { ...changes, highlightedIndex: 0 };
            default:
                return changes;
        }
    };
    const multiSelectReducer = (state, type, changes) => {
        switch (type) {
            case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
            case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
                if (!state.isOpen) {
                    return {
                        ...changes,
                        inputValue: '',
                        selectedItem: null,
                    };
                }
                return changes;
            case useCombobox.stateChangeTypes.InputKeyDownEnter:
            case useCombobox.stateChangeTypes.ItemClick:
                if (changes.selectedItem && !safeItemIsDisabled(changes.selectedItem)) {
                    callAddSelectedItem(changes.selectedItem);
                    callSelectItem(null);
                }
                return {
                    ...changes,
                    inputValue: '',
                    selectedItem: null,
                };
            case useCombobox.stateChangeTypes.InputKeyDownEscape:
            case useCombobox.stateChangeTypes.ToggleButtonClick:
            case useCombobox.stateChangeTypes.FunctionCloseMenu:
                selectInputEvent(selectInput, 'blur');
                return {
                    ...changes,
                    inputValue: '',
                    selectedItem: null,
                };
            case useCombobox.stateChangeTypes.FunctionOpenMenu:
                selectInputEvent(selectInput, 'focus');
                return {
                    ...changes,
                    inputValue: '',
                    selectedItem: null,
                };
            case useCombobox.stateChangeTypes.FunctionSelectItem:
                if (changes.selectedItem) {
                    callAddSelectedItem(changes.selectedItem);
                }
                if (!changes.isOpen) {
                    callOpenMenu();
                }
                return {
                    ...changes,
                    inputValue: '',
                    selectedItem: null,
                };
            case useCombobox.stateChangeTypes.InputFocus:
                updateFilteredItems(changes.inputValue);
                return {
                    ...changes,
                    inputValue: '',
                    selectedItem: null,
                };
            case useCombobox.stateChangeTypes.InputBlur:
                updateFilteredItems(changes.inputValue);
                return {
                    ...changes,
                    inputValue: '',
                };
            case useCombobox.stateChangeTypes.InputChange:
                updateFilteredItems(changes.inputValue);
                return changes.inputValue === '' ? changes : { ...changes, highlightedIndex: 0 };
            default:
                return changes;
        }
    };
    // State reducer for the SingleSelect and MultiSelect combobox
    const comboboxStateReducer = (state, actionAndChanges) => {
        const { type, changes } = actionAndChanges;
        if (isMultiSelect) {
            return multiSelectReducer(state, type, changes);
        }
        else {
            return singleSelectReducer(state, type, changes);
        }
    };
    return {
        comboboxStateReducer,
        multipleSelectionStateReducer,
    };
};
